import React from "react"
import FormGLAccount from "./Form";

export default function CreateGLAccount() {
  return <FormGLAccount />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/Create.js